import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { Admin } from '@/models/admin/admin.model';

export class GetAdminRequest extends ApiResourceMethod<Admin> {
  public perform(): Promise<Admin> {
    return this.performer.requestWithMapper(
      {},
      ({ data }: BaseResponse<Admin>): Admin => data,
    );
  }
}
